import { useState } from "react";
import {
    Container,
    Grid,
    AppBar,
    Tabs,
    Tab,
    Box,
} from "@material-ui/core";
import HomePage from "../../Home";
import PieChartIcon from '@material-ui/icons/PieChart';
import Utilidad from "../Utilidad";
import VIngresos from "../VIngresos";
import Egresos from "../Egresos";
import VCotizaciones from "../VCotizaciones";
import VModalReporte from "../VModalReporte";
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    }
}
const VReportes = () => {
    const [value, setValue] = useState(0)
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <Container>
                <Grid item xs={12}>
                    <h2>Reportes</h2>
                </Grid>
                <Grid item xs={12}>
                    <AppBar position="static" color="secondary">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="on"
                            indicatorColor="primary"
                            aria-label="scrollable force tabs example"
                        >
                            <Tab
                                label="Utilidad"
                                icon={<PieChartIcon />}
                                {...a11yProps(0)}
                            />
                            <Tab
                                label="Ingresos"
                                icon={<PieChartIcon />}
                                {...a11yProps(1)}
                            />
                            <Tab
                                label="Egresos"
                                icon={<PieChartIcon />}
                                {...a11yProps(2)}
                            />
                            <Tab
                                label="Cotizaciones"
                                icon={<PieChartIcon />}
                                {...a11yProps(3)}
                            />
                            <Tab
                                label="Imagenes compartidas"
                                icon={<PieChartIcon />}
                                {...a11yProps(4)}
                            />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        <Utilidad />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <VIngresos />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <Egresos />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <VCotizaciones />
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <VModalReporte />
                    </TabPanel>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VReportes